import React, { useState } from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '../../../../components/commonComponents/formComponents/dropDown'
import InputField from '../../../../components/commonComponents/formComponents/inputField'
import { AesStatusMappings } from '../../../../components/util'
import { AEScircuitVal } from '../mockConstants'

const AESExportMock = ({ formType, setAesData }) => {
  const [formData, setFormData] = useState({
    responseCode: '',
    aesStatus: '',
    circuit: '',
  })

  const responseCode = [
    {
      value: '0000',
      text: 'Accepted',
    },
  ]

  const aesStatusOptions = Object.keys(AesStatusMappings).map((key) => {
    return {
      value: key,
      text: AesStatusMappings[key].text,
    }
  })

  const handleInputChange = (id, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }))
    setAesData({...formData,[id]: value})
  }

  return (
    <Grid>
      <Grid.Row className='entry-number-row'>
        <Grid.Column width={5}>
          <DropDown
            style={{ borderColor: '#1765AE' }}
            type='text'
            id='ResponseCode'
            label='Response Code'
            className='status-dropdown field-bg dropdown100'
            data={responseCode}
            value={formData.responseCode}
            onChange={(value) => handleInputChange('responseCode', value)}
          />
        </Grid.Column>
        <Grid.Column width='8'className='divFormFeild'>
          <DropDown
            style={{ borderColor: '#1765AE' }}
            type='text'
            id='AesStatus'
            label='AES Status'
            className='field-bg dropdown100'
            data={aesStatusOptions}
            value={formData.aesStatus}
            onChange={(value) => handleInputChange('aesStatus', value)}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className='entry-number-row'>
        <Grid.Column width={6} className={`row-ur-mrn`}>
          <InputField
            isLabel={false}
            id='ProcessIndicator'
            className={'field-bg ur-mrn'}
            label='Process Indicator'
            disabled={true}
            value={formType}
          />
        </Grid.Column>

        <Grid.Column width={5}>
          <DropDown
            style={{ borderColor: '#1765AE' }}
            type='text'
            id='Circuit'
            label='Circuit'
            className='status-dropdown field-bg dropdown100'
            data={AEScircuitVal}
            value={formData.circuit}
            onChange={(value) => handleInputChange('circuit', value)}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

export default AESExportMock
